import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { useNavigate } from 'react-router-dom'
import Tab1 from './Tab1'
import { useCreateShipmentMutation, useUpdateShipmentMutation, useSubmitShipmentMutation } from "../../../../store/api/shipmentApi";
import Button from '../../../../Core/Button/Button'
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import Table from './Table'
import Attachment from '../../../../utils/Attachment'
function Shipmentform() {
    const [createShipment, { data, isLoading, errors }] = useCreateShipmentMutation();
    const [updateShipment, { data: updatedData, isLoading: isUpdating, error: updateError }] = useUpdateShipmentMutation();
    const [submitShipment, { isLoading: isSubmitting, error: submitError, data: submitData }] = useSubmitShipmentMutation();
    const [TableData, setTableData] = useState([]);
    const [selectedDeliveryNotes, setSelectedDeliveryNotes] = useState([]);
    const [selectedSalesInvoices, setSelectedSalesInvoices] = useState([]);
    const [deliveryNoteList, setDeliveryNoteList] = useState([]);
    const [salesinvoiceList, setsalesinvoiceList] = useState([]);
    const [fields, setFields] = useState({})
    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    const [tab, settab] = useState(1)
    const [ptype, setptype] = useState("Error ")
    const [showpopup, setShowpopup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [scanValue, setScanValue] = useState("");
    const [activityboll, setactivityboll] = useState(false)
    const [selectedDocTypes, setSelectedDocTypes] = useState([])
    const handleScan = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            setTableData((prev) => {
                const updated = prev.map(item =>
                    item.name === scanValue ? { ...item, is_verified: true } : item
                );
                const matchedItem = updated.find(item => item.name === scanValue);
                if (!matchedItem) return updated;
                const remainingItems = updated.filter(item => item.name !== scanValue);
                return [matchedItem, ...remainingItems];
            });
            setScanValue("");
        }
    };
    const [fieldErrors, setFieldErrors] = useState({
        pickupDate: false,
        date: false,
        handoverTime: false,
        logistics_provider: false,
        driver_mobile_number: false,
        drivername: false,
        driverLicense: false,
        discription: false,
        select_type: false,
        select_del_inv: false,
        select_sales_inv:false

    });


    const [po_response, setpo_response] = useState("");
    const [tab1Data, setTab1Data] = useState({});
    const [shipemntno, setshipemntno] = useState('');
    const validateForm = () => {

        const newError = {};
        // Validation
        if (!fields.pickupDate) newError.pickupDate = true;
        if (!fields.date) newError.date = true;
        if (!fields.handoverTime) newError.handoverTime = true;
        if (!fields.logistics_provider) newError.logistics_provider = true;
        if (!fields.driver_mobile_number) newError.driver_mobile_number = true;
        if (!fields.drivername) newError.drivername = true;
        if (!fields.driverLicense) newError.driverLicense = true;
        if (!fields.description) newError.description = true;
        if (selectedDocTypes.length === 0) newError.select_type = true;
        if (selectedDeliveryNotes.length === 0 && selectedDocTypes.includes("DeliveryNote")) newError.select_del_inv = true;
        if (selectedSalesInvoices.length === 0 && selectedDocTypes.includes("Sales Invoice")) newError.select_sales_inv = true;

        setFieldErrors(newError);
        return { isValid: Object.keys(newError).length === 0, newError };
    }
    // useEffect(() => {
    //     console.log("Updated fieldErrors:", fieldErrors);
    //     console.log("Updated Fields", fields);
        
    // }, [fieldErrors,fields]);
    const handleSave = async () => {
        // console.log("Fields",fields);
        
        const { isValid, newError } = validateForm();
        if (!isValid) {
            // Build a dynamic error message listing missing fields
            const missingFields = Object.keys(newError)
                .map(field => {
                    switch (field) {
                        case "pickupDate": return "Pickup Date";
                        case "date": return "Order Date";
                        case "handoverTime": return "Handover Time";
                        case "logistics_provider": return "Logistics Provider";
                        case "driver_mobile_number": return "Driver Mobile Number";
                        case "drivername": return "Driver Name";
                        case "driverLicense": return "Driver License";
                        case "description": return "Description";
                        case "select_type": return "Select Atleast 1 Document Type";
                        case "select_del_inv": return "Select Atleast 1 Delivery Invoice";
                        case "select_sales_inv": return "Select Atleast 1 Sales Invoice";
                        default: return field;
                    }
                });
            setError(`Required field(s) missing: ${missingFields.join(", ")}`);
            // setError("Required Field is Missing.");
            setptype("Error");
            setShowError(true);
            return;
        }
        const payload = {
            pickup_date: fields.pickupDate,
            posting_date: fields.date,
            handover_time: fields.handoverTime || "",
            logistics_provider: fields.logistics_provider,
            driver_mobile_number: fields.driver_mobile_number,
            driver_name: fields.drivername,
            driver_license_number: fields.driverLicense,
            description_of_content: fields.description || "",

            // Not Required , this Amount sum is Done in Backend Now
            // total_shipment_amount:
            //     deliveryNoteList
            //         .filter(note => selectedDeliveryNotes.includes(note.name))
            //         .reduce((sum, note) => sum + (note.grand_total || 0), 0) +
            //     salesinvoiceList
            //         .filter(inv => selectedSalesInvoices.includes(inv.name))
            //         .reduce((sum, inv) => sum + (inv.grand_total || 0), 0),


            delivery_notes: selectedDeliveryNotes.map(note => {
                const found = deliveryNoteList.find(d => d.name === note);
                return {
                    delivery_note: note,
                    value: found?.grand_total || 0,
                };
            }),

            sales_invoices: selectedSalesInvoices.map(note => {
                const found = salesinvoiceList.find(d => d.name === note);
                console.log(found, "found_check");

                return {
                    sales_invoice: note,
                    value: found?.grand_total || 0,
                };
            }),

            packing_slips: TableData.map(item => ({
                delivery_note: item.delivery_note,
                sales_invoice: item.sales_invoice || "",
                box_id: item.name,
                box_weight: item.gross_weight_pkg || 0,
                is_verified: item.is_verified ? 1 : 0,

            })),
        };


        try {
            const response = await createShipment(payload);
            console.log(response?.data?.data?.shipment, "shiptest2");
            console.log(response?.data, "shiptest1");

            if (response?.data?.shipment) {
                setFields(prev => ({
                    ...prev,
                    shipment: response?.data?.data?.shipment,
                }));
            }
            setpo_response(response);
            setshipemntno(response?.data?.data?.shipment);
            setItem(true);
            setError(`Shipment Saved ${response?.data?.data?.shipment}`);
            setptype('Created');
            setShowError(true);
            console.log("Order No:", response.data);

        } catch (err) {
            console.error("API Error:", err);

            const apiErrors = [];

            if (err?.data?.message) {
                apiErrors.push(err.data.message);
            } else if (err?.message) {
                apiErrors.push(err.message);
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
    };


    const handleUpdate = async () => {
        const payload = {
            shipment: shipemntno,
            pickup_date: fields.pickupDate,
            posting_date: fields.pickupDate,
            handover_time: fields.handoverTime || "",
            logistics_provider: fields.logistics_provider,
            driver_mobile_number: fields.driver_mobile_number,
            driver_name: fields.drivername,
            driver_license_number: fields.driverLicense,
            description_of_content: fields.description || "",

            // Not Required , this Amount sum is Done in Backend Now
            // total_shipment_amount:
            //     deliveryNoteList
            //         .filter(note => selectedDeliveryNotes.includes(note.name))
            //         .reduce((sum, note) => sum + (note.grand_total || 0), 0) +
            //     salesinvoiceList
            //         .filter(inv => selectedSalesInvoices.includes(inv.name))
            //         .reduce((sum, inv) => sum + (inv.grand_total || 0), 0),

            delivery_notes: selectedDeliveryNotes.map(note => {
                const found = deliveryNoteList.find(d => d.name === note);
                return {
                    delivery_note: note,
                    value: found?.grand_total || 0,
                };
            }),

            sales_invoices: selectedSalesInvoices.map(note => {
                const found = salesinvoiceList.find(d => d.name === note);
                return {
                    sales_invoice: note,
                    value: found?.grand_total || 0,
                };
            }),
            packing_slips: TableData.map(item => ({
                delivery_note: item.delivery_note,
                sales_invoice: item.sales_invoice || "",
                box_id: item.name,
                box_weight: item.gross_weight_pkg || 0,
                is_verified: item.is_verified ? 1 : 0,

            })),
        };
        try {
            const response = await updateShipment(payload).unwrap();
            setpo_response(response);
            setItem(true);
            setError(`Shipment Updated ${shipemntno}`);
            setptype('Updated');
            setShowError(true);

        } catch (err) {
            console.error("API Error:", err);

            const apiErrors = [];

            if (err?.data?.message) {
                apiErrors.push(err.data.message);
            } else if (err?.message) {
                apiErrors.push(err.message);
            } else {
                apiErrors.push("Something went wrong while saving the order.");
            }

            setError(apiErrors);
            setptype("Error");
            setShowError(true);
        }
    };



    // const handleSubmit = async () => {
    //     const payload = { shipment: shipemntno };
    //     try {
    //         const res = await submitShipment(payload);

    //         if (res.status === 400) {
    //             const errorMessage = res?.data?.message || 'Unexpected error occurred';
    //             setError('Error');
    //             setptype(errorMessage);
    //             setShowError(true);
    //             console.error('Error message from API:', errorMessage);
    //             return;
    //         }
    //         setButtonData(true);
    //         setactivityboll(true);
    //         setError('submitted');
    //         setptype('Shipment Submitted');
    //         setShowError(true);

    //     } catch (err) {
    //         console.error("Error caught:", err);
    //         const errorMessage = err?.data?.message || 'Unexpected error occurred';
    //         setError('Error');
    //         setptype(errorMessage);
    //         setShowError(true);
    //     }
    // };
    const handleSubmit = async () => {
    const payload = { shipment: shipemntno };
    try {
        const res = await submitShipment(payload);
        console.log(res, "res_submit");

        // Check for error response (status 500 with error message)
        if ( res.error?.data?.message) {
            // Try to extract the detailed error message
            let errorMessage = res.error.data.message;
            
            // Parse the _server_messages if available
            if (res.error.data._server_messages) {
                try {
                    const messages = JSON.parse(res.error.data._server_messages);
                    if (Array.isArray(messages) && messages.length > 0) {
                        const firstMessage = JSON.parse(messages[0]);
                        errorMessage = firstMessage.message || errorMessage;
                    }
                } catch (e) {
                    console.error("Error parsing server messages:", e);
                }
            }

            setError(errorMessage);
            setptype('Error');
            setShowError(true);
            return; 
        }

        setButtonData(true);
        setactivityboll(true);
        setError('submitted');
        setptype('Shipment Order submitted');
        setShowError(true);

    } catch (err) {
        console.error("Error caught:", err);
        let errorMessage = 'Unexpected error occurred';
        
        // Handle different error formats
        if (err?.response?.data) {
            const errorData = err.response.data;
            errorMessage = errorData.message || errorMessage;
            
            if (errorData._server_messages) {
                try {
                    const messages = JSON.parse(errorData._server_messages);
                    if (Array.isArray(messages) && messages.length > 0) {
                        const firstMessage = JSON.parse(messages[0]);
                        errorMessage = firstMessage.message || errorMessage;
                    }
                } catch (e) {
                    console.error("Error parsing server messages:", e);
                }
            }
        } else if (err.message) {
            errorMessage = err.message;
        }
  
           setError(errorMessage);
            setptype('Error');
        setShowError(true);
    }
};
    const totalVal = deliveryNoteList
        .filter(note => selectedDeliveryNotes.includes(note.name))
        .reduce((sum, note) => sum + (note.grand_total || 0), 0);
    const verifiedCount = TableData.filter(item => item.is_verified).length;


    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between " style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/shippinglist')}>Shipment List  </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }} >
                        New Shipment
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {buttonData ? 'Submitted' : item ? 'Draft' : 'New'}
                        </button>
                    </a>
                </div>

                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    <Button
                        className="custom-btn-bluecolor d-flex"
                        iconName="BiCloudUpload"
                        style={{ gap: '2px' }}
                        iconSize={14}
                        onClick={() => { setShowpopup(true) }}
                    >
                        Upload
                    </Button>
                    {shipemntno && !buttonData && (
                        <Button
                            style={{ gap: '2px' }}
                            className="custom-btn-00989"
                            iconName="LuFilePlus2"
                            iconSize={12}
                            onClick={handleUpdate}
                        >
                            Update
                        </Button>
                    )}

                    {item && !buttonData ? (
                        <Button
                            className="custom-btn-00989"
                            onClick={handleSubmit}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}>
                            Submit

                        </Button>
                    ) : item && buttonData ? (
                        ''
                    ) : (
                        <Button
                            className="custom-btn-00989"
                            onClick={handleSave}
                            iconName="LuFilePlus2"
                            style={{ gap: '2px', height: '28px' }}
                            iconSize={12}>
                            Save
                        </Button>

                    )}
                    {/* <Button
                        className="custom-btn-00989"
                        onClick={handleSave}
                        iconName="LuFilePlus2"
                        style={{ gap: '2px', height: '28px' }}
                        iconSize={12}>
                        Save
                    </Button> */}
                </div>
            </div>
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul className="nav nav-tabs mb-0" style={{ color: "white", border: "none" }}>
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>
                        </ul>
                       {shipemntno && <Attachment doctype="Shipment"  docname={shipemntno}  /> }
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    <div className="col-3 sidebarbox" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}>
                        <Tab1
                            fields={fields}
                            setFields={setFields}
                            selectedDeliveryNotes={selectedDeliveryNotes}
                            setSelectedDeliveryNotes={setSelectedDeliveryNotes}
                            setDeliveryNoteList={setDeliveryNoteList}
                            setsalesinvoiceList={setsalesinvoiceList}
                            setTab1Data={setTab1Data}
                            setTableData={setTableData}
                            fieldErrors={fieldErrors}
                            activityboll={activityboll}
                            shipemntno={shipemntno}
                            setSelectedSalesInvoices={setSelectedSalesInvoices}
                            selectedSalesInvoices={selectedSalesInvoices}
                            selectedDocTypesC={selectedDocTypes}
                            setSelectedDocTypesC={setSelectedDocTypes}
                        />
                    </div>
                    {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>
                        <div className="d-flex justify-content-between align-items-center pb-2" style={{ gap: '5px' }}>
                            <div className="d-flex pb-2" style={{ gap: '5px' }}>
                                <p className="NoOfLine">No.of Lines - <span style={{ color: '#2563EB' }}> {TableData.length}</span></p>
                                <p className="NoOfLine">No.of DeliveryNotes - <span style={{ color: '#2563EB' }}> {selectedDeliveryNotes.length}</span></p>
                                <p className="NoOfLine">No.of SalesInvoices - <span style={{ color: '#2563EB' }}> {selectedSalesInvoices.length}</span></p>
                                <p className="TotalQty">Value of Goods -  <span style={{ color: '#16A34A' }}> {totalVal}</span></p>
                                <p className="TotalQty">Scanned Boxes -  <span style={{ color: '#16A34A' }}> {verifiedCount}</span></p>
                            </div>
                            <div className='px-3 '>
                                <form>
                                    <div className="position-relative" style={{ width: "227px" }}>
                                        <div style={{ position: "relative" }} title="Scan Bin">
                                            <input
                                                type="text"
                                                placeholder="Scan Box"
                                                className="form-control pe-4"
                                                value={scanValue}
                                                onChange={(e) => setScanValue(e.target.value)}
                                                onKeyDown={handleScan}
                                                style={{
                                                    width: "100%",
                                                    border: "1px solid #333",
                                                    backgroundColor: "#fff",
                                                    fontSize: "12.8px",
                                                }}
                                            />
                                            <div
                                                style={{
                                                    position: "absolute",
                                                    top: "50%",
                                                    right: "40px",
                                                    transform: "translateY(-50%)",
                                                    pointerEvents: "none",
                                                    color: "#999",
                                                }}
                                            >
                                                <GetIcon iconName="MdBlock" size={16} />
                                            </div>
                                        </div>

                                        <button
                                            type="button"
                                            className="position-absolute"
                                            style={{
                                                top: "50%",
                                                right: "10px",
                                                transform: "translateY(-50%)",
                                                background: "none",
                                                border: "none",
                                                padding: 0,
                                                color: "#EC642A",
                                            }}
                                            title="Scan Box"
                                            disabled
                                        >
                                            <GetIcon iconName="BsUpcScan" design="cursor-pointer" size={15} />
                                        </button>
                                    </div>


                                </form>

                            </div>

                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            TableData={TableData}


                        />
                        {/* here */}
                    </div>
                        : ''}

                </div>
            </div>

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />


        </>
    )
}

export default Shipmentform
